import {isUndefined, cloneDeep} from 'lodash';
import {GET_PERSONAL_CONTENT, UPDATE_PERSONAL_ITEM, RESET_PERSONAL_CONTENT} from '../constants';

const initialState = {
	data: null,
};

const addPersonalList = (psList, psData, dataType) => {
	let newData = {};
	if (psList !== null) {
		newData = {...cloneDeep(psList)};
		if (isUndefined(psList[dataType])) {
			newData[dataType] = {};
		}
	} else {
		newData[dataType] = {};
	}
	for (let i = 0; i < psData.contents.length; i += 1) {
		const psItem = psData.contents[i];
		const obj = {};
		if (!isUndefined(psItem.playlist)) {
			obj.playlist = psItem.playlist;
		}
		if (!isUndefined(psItem.favorite)) {
			obj.favorite = psItem.favorite;
		}
		if (!isUndefined(psItem.watchHistory)) {
			obj.watchHistory = psItem.watchHistory;
		}
		newData[dataType][psItem.id] = obj;
	}

	return newData;
};

const updatePersonalItem = (psList, psId, psType, psValue, dataType) => {
	let newData = {};
	if (psList !== null) {
		newData = {...cloneDeep(psList)};
		if (isUndefined(psList[dataType])) {
			newData[dataType] = {};
		}
	} else {
		newData[dataType] = {};
	}
	if (isUndefined(newData[dataType][psId])) {
		newData[dataType][psId] = {};
	}
	newData[dataType][psId][psType] = psValue;

	return newData;
};

const personal = (state = initialState, action) => {
	switch (action.type) {
		case RESET_PERSONAL_CONTENT:
			return initialState;
		case GET_PERSONAL_CONTENT:
			return {...state, data: addPersonalList(state.data, action.psData, action.dataType)};
		case UPDATE_PERSONAL_ITEM:
			return {...state,
				data: updatePersonalItem(state.data, action.contentId,
						action.psType, action.psValue, action.dataType),
			};
		default:
			return state;
	}
};

export default personal;
